import './components/toast';
import './components/ajaxProgress';
import './components/states.js';

(function () {
  // 检测是否在微信小程序 webview 中
  function detectMiniProgram() {
    const userAgent = navigator.userAgent.toLowerCase();
    const isWechat = userAgent.indexOf('micromessenger') > -1;
    const isMiniProgram =
      userAgent.indexOf('miniprogram') > -1 || window.__wxjs_environment === 'miniprogram';

    if (isWechat) {
      document.documentElement.classList.add('is-wechat');
    }
    if (isMiniProgram) {
      document.documentElement.classList.add('is-miniprogram');
    }
  }
  detectMiniProgram();

  // 自定义菜单 icon
  const menuItem = document.querySelectorAll('.toolbar-icon[data-toolbar-custom-icon]');
  if (menuItem.length) {
    menuItem.forEach(item => {
      const iconParams = item.getAttribute('data-toolbar-custom-icon');
      const [type, val] = iconParams.split('|');
      if (!type || !val) {
        item.removeAttribute('data-toolbar-custom-icon');
        return;
      }

      let beforeIcon;
      if (type === 'image') {
        beforeIcon = `<img class="toolbar-custom-icon" src="${val}" alt="icon" />`;
      } else if (type === 'iconfont') {
        beforeIcon = `<i class="toolbar-custom-icon ${val}"></i>`;
      }

      if (beforeIcon) {
        item.insertAdjacentHTML('afterbegin', beforeIcon);
      } else {
        item.removeAttribute('data-toolbar-custom-icon');
      }
    });
  }

  // 表格外部 器宽度
  let _tableSetCssVar = document.querySelectorAll('.gin-table-scroll-wrapper');
  if (_tableSetCssVar.length) {
    function tableWrapWidthSetCssVar() {
      _tableSetCssVar.forEach(wrap => {
        let width = wrap.offsetWidth;
        wrap.style.setProperty('--gin-table-scroll-wrapper-width', `${width}px`);
      });
    }
    tableWrapWidthSetCssVar();
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(tableWrapWidthSetCssVar, 200);
    });
  }
})();
